import { Spinner } from '../../../icons/Spinner'

// improve with cell defined skeleton loading
export const Loader = ({ cols }: { cols: number }) => (
    <tr>
        <td colSpan={cols}>
            <div className="flex min-h-80 items-center justify-center">
                <Spinner size="lg" />
            </div>
        </td>
        <td />
    </tr>
)
